// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Me4O","colMin":"styles_colMin__JtYzQ","colCheckbox":"styles_colCheckbox__1zbGH"};